module.exports = __webpack_public_path__ + "static/media/ubuntu-hippo.70bcf48c.png";